import assign from 'object-assign';
import $ from 'balajs';
import detect from './detect'
import store from './store'

var doc = document,
    navi = navigator,
    reUnescapedHtml = /[&<>"'`\\]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source),
    reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#x60|#x5c);/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source),
    escapeMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '`': '&#x60;',
        '\\': '&#x5c;'
    },
    unescapeMap = {}
for (var key in escapeMap) {
    unescapeMap[escapeMap[key]] = key
}
var timer = null

if (!Array.prototype.forEach) {
    Array.prototype.forEach = function(callback, thisArg) {
        var T, k
        if (this == null) throw new TypeError(' this is null or not defined')
        var O = Object(this)
        var len = O.length >>> 0
        if (typeof callback !== 'function') throw new TypeError(callback + ' is not a function')
        if (arguments.length > 1) T = thisArg
        k = 0
        while (k < len) {
            var kValue
            if (k in O) {
                kValue = O[k]
                callback.call(T, kValue, k, O)
            }
            k++
        }
    }
}
if (window.NodeList && !NodeList.prototype.forEach) NodeList.prototype.forEach = Array.prototype.forEach

if (!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
}
assign($.fn, {
    prepend(child){
        if (!(child instanceof HTMLElement)) child = child[0]
        this.forEach(el => {
            el.insertAdjacentElement('afterBegin',child)
            // el.appendChild(child)
        })
        return this
    },
    /**
     * 只能是一个 HTMLElement 元素或者 HTMLElement 数组，不支持字符串
     * @param {Element|Element[]} child
     * @returns {append}
     */
    append(child) {
        if (!(child instanceof HTMLElement)) child = child[0]
        this.forEach(el => {
            el.insertAdjacentElement('beforeEnd',child)
            // el.appendChild(child)
        })
        return this
    },
    remove() {
        this.forEach(el => {
            try{el.parentNode.removeChild(el)}catch(ex){}
        })
        return this
    },
    find(selector) {
        return $(selector, this)
    },
    show() {
        this.forEach(el => {
            el.style.display = 'block'
        })
        return this
    },
    hide() {
        this.forEach(el => {
            el.style.display = 'none'
        })
        return this
    },
    on: function (eventType, handler, capture) {
        $.fn.off(eventType, handler, capture)
        this.forEach(el => {
            eventType.split(' ').forEach(event => {
                if (el.addEventListener) el.addEventListener(event, handler, capture || false)
                else if (el.attachEvent) el.attachEvent(`on${event}`, handler)
                else el[`on${event}`] = handler
            });
        });
        return this;
    },
    off: function (eventType, handler, capture) {
        this.forEach(el => {
            eventType.split(' ').forEach(event => {
                if (el.removeEventListener) el.removeEventListener(event, handler, capture || false)
                else if (el.detachEvent) el.detachEvent(`on${event}`, handler)
                else el[`on${event}`] = null
            });
        });
        return this;
    },
    html(v) {
        if(v !== void 0){
            this.forEach(el => {
                el.innerHTML = v
            })
            return this
        }
        return this[0].innerHTML
    },
    text(v){
        if (v !== void 0) {
            this.forEach(el => {
                el.innerText = v
            })
            return this
        }
        return this[0].innerText
    },
    empty(v){
        v = v || 0
        this.forEach(el=>{
            setTimeout(e=>{
                el.innerText = ''
            },v)
        })
        return this
    },
    val(v) {
        if (v !== void 0) {
            this.forEach(el => {
                el.value = v
            })
            return this
        }
        return (this[0].value || '')
    },
    attr: function() {
        if (typeof arguments[0] == 'object') {
            var attrsObj = arguments[0]
            var that = this
            Object.keys(attrsObj).forEach(attr => {
                that.forEach(el => {
                    el.setAttribute(attr, attrsObj[attr])
                })
            })
            return this
        }

        if (typeof arguments[0] == 'string' && arguments.length < 2) {
            return this[0].getAttribute(arguments[0]) || ''
        }

        this.forEach(el => {
            el.setAttribute(arguments[0], arguments[1])
        })
        return this
    },
    removeAttr(names) {
        this.forEach(el => {
            var name,
                i = 0,
                // Attribute names can contain non-HTML whitespace characters
                // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
                attrNames = names && names.match(/[^\x20\t\r\n\f\*\/\\]+/g);
            if (attrNames && el.nodeType === 1) {
                while ((name = attrNames[i++])) {
                    el.removeAttribute(name);
                }
            }
        })
        return this;
    },
    hasClass( cls ) {
        return !!this[ 0 ] && new RegExp('(\\s|^)' + cls + '(\\s|$)').test(this[ 0 ].getAttribute('class')); 
    },
    addClass( cls ) {
        this.forEach( el => {
            var $el = $(el),
                className = $el.attr('class')
            $el.hasClass(cls) ? "" : $el.attr('class',className += " " + cls); 
        });
        return this;
    },
    removeClass( cls ) {
        this.forEach( el => {
            var $el = $(el),
                className = $el.attr('class')
            if($el.hasClass(cls)){
                var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)'); 
                $el.attr('class',className.replace(reg, '')); 
            }
        });
        return this;
    },
});
assign($, {
    extend:assign,
    noop() {},
    navi,
    ua: navi.userAgent,
    lang: navi.language || navi.languages[0],
    detect,
    store,
    escape(s) {
        return s && reHasUnescapedHtml.test(s)
            ? s.replace(reUnescapedHtml, chr => escapeMap[chr])
            : s
    },
    unescape(s) {
        return s && reHasEscapedHtml.test(s)
            ? s.replace(reEscapedHtml, entity => unescapeMap[entity])
            : s
    },

    dynamicLoadSource(src, cb) {
        if ($(`script[src="${src}"]`).length) cb && cb();
        else {
            var s = doc.createElement('script');
            s.onload = s.onreadystatechange = function() {
              const vm = this;
              if (!0 || /loaded|complete/.test(vm.readyState)) {
                vm.onload = vm.onreadystatechange = null;
                cb && cb();
                $(s).remove()
              }
            };
            s.async = true
            s.setAttribute('referrerPolicy','no-referrer')
            var h = $("head")[0];
            h.appendChild(s);
            s.src = src;
        }
    },
    sdkLoader(uri,x,cb) {
        if (x in window && !!window[x]) {
            timer && clearTimeout(timer);
            cb && cb()
        } else {
            $.dynamicLoadSource(uri, () => {
                timer = setTimeout($.sdkLoader(uri,x,cb), 100);
            });
        }
    },
    deleteInWin(x,t){
        let fn = e =>{
            if(x in window){
                try {
                    delete window[x]
                } catch (ex) {
                    window[x] = null
                }
            }
        }
        if(t === 0) fn()
        else setTimeout(fn, t || 500)
    },
    ajax(opts) {
        opts = opts || {};
        opts.type = (opts.type || "GET").toUpperCase();
        opts.dataType = opts.dataType || 'json';
        opts.async = opts.async || true;
        opts.timeout=opts.timeout||8000;//超时处理，默认8s
        let obj2str = data=> {
            var arr = [];
            for (var key in data) {
                arr.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
            }
            arr.push('t='+Date.now())
            return arr.join('&');
        };
        var params = ({}).toString.call(opts.data) == "[object FormData]" ? opts.data : obj2str(opts.data)
        var timer=null;
        var xhr = 'XMLHttpRequest' in window ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP')
        xhr.onreadystatechange = e=> {
            if (xhr.readyState == 4) {
                clearTimeout(timer);
                var status = xhr.status;
                if (status >= 200 && status < 300) opts.success && opts.success(JSON.parse(xhr.responseText));
                else opts.fail && opts.fail(status);
            }
        };
        if (opts.type == 'GET') {
            xhr.open("GET", opts.url + '?' + params, opts.async);
            xhr.send(null)
        } else if (opts.type == 'POST') {
            xhr.open('POST', opts.url, opts.async);
            if(({}).toString.call(opts.header) == '[object Object]'){
                for(let key in opts.header){
                    if(opts.header.hasOwnProperty(key)){
                        let header = opts.header[key]
                        xhr.setRequestHeader(key,header)
                    }
                }
                // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                xhr.send(JSON.stringify(opts.data));
            }else{
                xhr.send(params);
            }
        }
        timer=setTimeout(x=>{//计时器，超时后处理
            clearTimeout(timer);
            xhr.abort();
        },opts.timeout);
    }
})

export default $
